/**
 * มั่งมีทรัพย์ logomark (โมโนแกรม M เหลี่ยมตามโลโก้จริง: แท่งทองซ้าย + M เฉียง)
 * + ป้ายชื่อ "มั่งมีทรัพย์" (optional).
 *
 *   <Logo />                          → mark only
 *   <Logo wordmark />                 → mark + "มั่งมีทรัพย์"
 *   <Logo white />                    → mark/text เป็นสีขาว (สำหรับพื้น gradient)
 *   <Logo wordmark sub="PayPilot" />  → เพิ่มป้ายผลิตภัณฑ์ใต้ชื่อ
 *   <Logo surface="dark" wordmark />  → ทอง/อ่อน สำหรับ sidebar ดำ (Luxury Ledger)
 *
 * ใช้ SVG inline (ไม่พึ่ง raster asset) → currentColor คุมสี M ได้ตามพื้น.
 */
interface Props {
  /** Tailwind height class for the mark, e.g. "h-8" (default). */
  size?: string;
  white?: boolean;
  wordmark?: boolean;
  /**
   * พื้นที่โลโก้วางอยู่. `'dark'` = ทอง/อ่อน ให้เห็นบน sidebar ดำ.
   */
  surface?: 'light' | 'dark';
  /** ป้ายผลิตภัณฑ์เล็กใต้ชื่อ. */
  sub?: string;
  className?: string;
}

export function Logo({ size = 'h-8', white = false, wordmark = false, surface = 'light', sub, className = '' }: Props) {
  const dark = surface === 'dark';
  const wordColor = white ? 'text-white' : dark ? 'text-[#e0d9c8]' : 'text-ink';
  const subColor = white ? 'text-white/80' : dark ? 'text-[#8f877e]' : 'text-warm-gray';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src="/ruaylonfa-logo.jpg" alt="ร่ำรวยล้นฟ้า" className={`${size} aspect-square object-cover rounded-md shadow-sm`} />
      {wordmark && (
        <span className="leading-none">
          <span className={`font-display font-semibold text-lg ${wordColor}`}>ร่ำรวยล้นฟ้า</span>
          {sub && <span className={`block text-[10px] tracking-[.2em] uppercase mt-0.5 ${subColor}`}>{sub}</span>}
        </span>
      )}
    </span>
  );
}
